<!-- <div class="table-container">
  <table class="result-table" style="table-layout: fixed;">
    <thead>
      <tr class="font-weight-bold">
        <th style="width: 20%;">Name</th>
        <th style="width: 20%;">URL</th>
        <th class="text-center" style="width: 7.5%;">Category</th>
        <th class="text-center" style="width: 25%;">Start time & End time</th>
        <th class="text-center" style="width: 7.5%;">Response</th>
        <th class="text-center" style="width: 10%;">Status</th>
        <th class="text-center" *ngIf="testCaseDetail?.iterable" style="width: 7.5%;">Iteration</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="!tcExecData?.downStreamResult && tcExecData?.downStreamWarning">
        <td colspan="6" class="text-danger">{{tcExecData?.downStreamWarning}}</td>
      </tr>
      <tr *ngFor="let endPoint of tcExecData?.endPoints | orderBy:'asc':'sequence'; let i=index" [ngClass]="{'active' : endPoint?.noSqlId === endPointResults?.noSqlId }" class="clickable" (click)="readEPDetailFromNoSql(endPoint.noSqlId, i, true);">
        <td class="text-truncate" title="{{endPoint.name}}">
          <span class="badge" [hidden]="!endPoint.subFlow" ngbTooltip="Sub flow">SF</span>
          <a [routerLink]="['/endpoint',endPoint.sqlId]" target="_blank">
            <i class="fas fa-link" ngbTooltip="Go to endpoint" placement="right"></i>
          </a>
          {{endPoint.sequence}}. {{endPoint.name}}
        </td>
        <td class="text-truncate" title="{{endPoint.endPointExecution.uri}}">{{endPoint.endPointExecution.uri}}</td>
        <td class="text-uppercase text-center">
          <span class="api-rest-box" [ngClass]="{'api-rest-box' : endPoint?.endPointType === 'REST','api-web-box' : endPoint?.endPointType === 'WEB','api-soap-box' : endPoint?.endPointType ==='SOAP'}">{{endPoint?.endPointType}}</span>
        </td>
        <td class="text-center">{{(endPoint.endPointExecution.startTime | localDate) || 'NA' }} - {{(endPoint.endPointExecution.endTime | localDate) || 'NA'}}</td>
        <td class="text-center">{{endPoint.endPointExecution.apiResponseTime | secondsToHms}}</td>
        <td class="text-center">
          <div class="status-badge status-{{ endPoint.endPointExecution['executionStatus'].toLowerCase() }}" [title]="endPoint.endPointExecution['executionStatus']">
            <i class="fas" [ngClass]="{
                    'fa-clock': endPoint.endPointExecution['executionStatus'] === 'PENDING',
                    'fa-check-circle': endPoint.endPointExecution['executionStatus'] === 'PASSED',
                    'fa-redo': endPoint.endPointExecution['executionStatus'] === 'SKIPPED',
                    'fa-times-circle': endPoint.endPointExecution['executionStatus'] === 'FAILED',
                    'fa-hand-paper': endPoint.endPointExecution['executionStatus'] === 'ABORTED',
                    'fa-sync-alt fa-spin': endPoint.endPointExecution['executionStatus'] === 'IN_PROGRESS',
                    'fa-step-forward': endPoint.endPointExecution['executionStatus'] === 'VALID_SKIP',
                    'fa-exclamation-triangle': endPoint.endPointExecution['executionStatus'] === 'VALID_FAILED',
                    'fa-arrows-alt': endPoint.endPointExecution['executionStatus'] === 'VALID_JUMP',
                    'fa-pause-circle': endPoint.endPointExecution['executionStatus'] === 'PAUSED',
                    'fa-bug': endPoint.endPointExecution['executionStatus'] === 'RELAY_ERROR',
                    'fa-forward': endPoint.endPointExecution['executionStatus'] === 'ACTION_SKIP'
                  }"></i>
          </div>
          <a (click)="showPwVideo(testCaseExecutionResult?.execution?.noSqlId, endPoint.endPointExecution.noSqlId)" class="ml-2">
            <i class="fas fa-video" ngbTooltip="Show Video" placement="left"></i>
          </a>
        </td>
        <td class="text-center" *ngIf="testCaseDetail?.iterable">{{endPoint.endPointExecution.iteration}}</td>
      </tr>
    </tbody>
  </table>
</div> -->

<div class="endpoint-details-overlay" [ngClass]="{'show': showOverlay, 'full-screen': showFullScreen}">
  <!-- Header -->
  <div class="endpoint-details-header">
    <h3>{{endPointResults.name}}</h3>
    <div class="d-flex ml-auto">
      <button class="close-btn" (click)="openMobileConfigurationDialog()" *ngIf="(endPointResults?.mobileEndPoint || endPointResults?.desktopEndPoint) &&  endPointResults.environment && endPointResults.environment.mobileConfiguration" ngbTooltip="{{endPointResults?.mobileEndPoint ? 'Mobile' : 'Desktop'}} Configuration">
        <i class="fas fa-cogs"></i>
      </button>
      <button class="close-btn" (click)="showFullScreen = !showFullScreen;">
        <i class="fas fa-expand-arrows-alt"></i>
      </button>
      <button class="close-btn" (click)="showOverlay = false; showFullScreen = false; updateOverlay.emit(false)">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>
  <div class="header-container" *ngIf="showOverlay">
    <div class="result-header">
      <div class="header-content">
        <div class="header-left">
          <div class="execution-details row" *ngIf="!endPointResults?.mobileEndPoint && !endPointResults?.desktopEndPoint">
            <div class="col-md-4 execution-item">
              <span class="label font-weight-bold">Request Type :</span>
              <span class="value">{{endPointResults.requestType}}</span>
            </div>
            <div class="col-md-4 execution-item">
              <span class="label font-weight-bold">Response Type :</span>
              <span class="value">{{endPointResults.responseType}}</span>
            </div>
            <div class="col-md-4 execution-item">
              <span class="label font-weight-bold">Execution Success :</span>
              {{!endPointExec?.exception}}
            </div>
            <div class="col-md-4 execution-item">
              <span class="label font-weight-bold">Domain :</span>
              {{endPointResults.environment?.subDomain}}
            </div>
            <div class="col-md-4 execution-item">
              <span class="label font-weight-bold">URI :</span>
              {{ endPointExec?.uri}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ul ngbNav #nav="ngbNav" class="testdata-nav nav-tabs m-2" style="border-bottom: 1px solid #a8a8a8;" [(activeId)]="activeTabId" (navChange)="changeTab($event)">
    <!--  Mobile Instruction -->
    <li title="Response" [ngbNavItem]="10" *ngIf="!endPointResults.webEndPoint && !endPointResults.mobileEndPoint && !endPointResults.desktopEndPoint">
      <a ngbNavLink><i class="fas fa-tasks mr-2"></i>Response</a>
      <ng-template ngbNavContent>
        <div class="row">
          <div class="report-visualization col-6" *ngIf="endPointResults.responseType !== 'FILE'">
            <div class="stats-panel">
              <div class="panel-header">
                <h3 class="panel-title">Response Body</h3>
              </div>
            </div>
            <div class="stats-body">
              <div class="overflow">
                <div *ngIf="endPointExec.responseBody !== null && !endPointExec.lazy" class="response-body" [ngSwitch]="true">
                  <div *ngSwitchCase="endPointExec.responseType==='JSON' || endPointExec.responseType==='XML'">
                    <ngx-json-viewer [json]="endPointExec.responseBody"></ngx-json-viewer>
                  </div>
                  <div *ngSwitchDefault>
                    <pre style="min-height: 10vh;">{{endPointExec.responseBody}}</pre>
                  </div>
                </div>
                <div class="response-body" [ngSwitch]="true" *ngIf="endPointExec.lazy">
                  <a (click)="lazyLoadResponseBody(endPointExec.noSqlId)">Data is too long. Click here to view the data.</a>
                </div>
              </div>
            </div>
          </div>

          <!-- Response Headers -->
          <div class="report-visualization col-6">
            <div class="stats-panel">
              <div class="panel-header">
                <h3 class="panel-title">Response Headers</h3>
              </div>
            </div>
            <div class="stats-body">
              <div class="overflow">
                <div class="" *ngIf="endPointExec?.responseHeaders">
                  <ngx-json-viewer [json]="endPointExec?.responseHeaders"></ngx-json-viewer>
                </div>
                <div class="" *ngIf="!endPointExec?.responseHeaders"> No data </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </li>

    <li title=" Mobile Instruction" [ngbNavItem]="0" *ngIf="endPointResults?.mobileEndPoint || endPointResults?.desktopEndPoint">
      <a ngbNavLink><i class="fas fa-list-ul mr-2"></i>{{endPointResults?.mobileEndPoint ? 'Mobile' : 'Desktop'}} Instructions</a>
      <ng-template ngbNavContent>
        <!-- Mobile Instruction Result -->
        <app-mobile-result [mostRecentExecuted]="endPointResults" [mobileInstructions]="endPointExec?.mobileInstructions" [parentIndex]="selectedEndpointIndex" [showGraphSection]="false"></app-mobile-result>
      </ng-template>
    </li>
    <!-- Web Instruction -->
    <li title="Web Instruction" [ngbNavItem]="1" *ngIf="endPointResults.webEndPoint">
      <a ngbNavLink><i class="fas fa-list-ul mr-2"></i>Web Instruction</a>
      <ng-template ngbNavContent>
        <div class="row mr-2">
          <i class="fas fa-sync clickable m-2 ml-auto" *ngIf="webInstructionExpandable" ngbTooltip="Refresh" placement="left" (click)="getExecutedWebInstructionList(); $event.stopPropagation();"></i><br>
        </div>
        <div class="desc row ml-2 mr-2 mt-1" *ngIf="webInstructionExpandable && projectConfiguration !== 'PLAYWRIGHT'">
          <div class="table-container compact-table">
            <table class="result-table table-hover relay-word-wrap">
              <thead>
                <tr>
                  <th width="15%">Name</th>
                  <th width="15%">Locator</th>
                  <th width="15%">Input</th>
                  <th>Action</th>
                  <th>Wait Time</th>
                  <th class="text-center">Response(in sec)</th>
                  <th>Status</th>
                  <th width="10%" class="text-center">Screenshot</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let webInstruction of endPointExec?.webInstructions | orderBy:'asc':'sequence' ; index as ind;" [ngClass]="{'active' : (webInstActive === webInstruction.noSqlId),'inactive' : !webInstruction.active}">
                  <td>
                    <span [hidden]='!(webInstruction.active && webInstruction.domExtractors?.length > 0)' class="clickable fas" [ngClass]="(webResCollapsed && (webInstActive === webInstruction.noSqlId)) ? 'fa-chevron-circle-up' : 'fa-chevron-circle-down'" (click)="getResDomExtra(webInstruction.noSqlId)"></span>
                    {{webInstruction.name}}
                  </td>
                  <td>
                    <app-locator-pop-over [locator]="webInstruction.webLocator" [triggers]="'click'" class="overflow-table-display" style="width: 85%"></app-locator-pop-over>
                    <i class="far fa-edit clickable m-1" *ngIf="webInstruction.webLocator" (click)="editWebInstruction(webInstruction.webLocator, 'webLocator');" title="Edit Web Instruction"></i>
                  </td>
                  <td>{{webInstruction.componentInput}}</td>
                  <td>{{webInstruction.actionOnComponent}}</td>
                  <td>{{webInstruction.webLocator?.waitTime}}</td>
                  <td class="text-center">{{webInstruction?.webInstructionResponseTime}}</td>
                  <td>
                    <div class="status-badge status-{{ webInstruction['executionStatus']?.toLowerCase() }}" [title]="webInstruction['executionStatus'] || 'DISABLED'">
                      <i class="fas" [ngClass]="{
                        'fa-clock': webInstruction['executionStatus'] === 'PENDING',
                        'fa-check-circle': webInstruction['executionStatus'] === 'PASSED',
                        'fa-redo': webInstruction['executionStatus'] === 'SKIPPED',
                        'fa-times-circle': webInstruction['executionStatus'] === 'FAILED',
                        'fa-hand-paper': webInstruction['executionStatus'] === 'ABORTED',
                        'fa-sync-alt fa-spin': webInstruction['executionStatus'] === 'IN_PROGRESS',
                        'fa-step-forward': webInstruction['executionStatus'] === 'VALID_SKIP',
                        'fa-exclamation-triangle': webInstruction['executionStatus'] === 'VALID_FAILED',
                        'fa-arrows-alt': webInstruction['executionStatus'] === 'VALID_JUMP',
                        'fa-pause-circle': webInstruction['executionStatus'] === 'PAUSED',
                        'fa-bug': webInstruction['executionStatus'] === 'RELAY_ERROR',
                        'fa-forward': webInstruction['executionStatus'] === 'ACTION_SKIP',
                        'fa-not-equal': webInstruction['executionStatus'] === null
                      }"></i>
                    </div>
                  </td>
                  <td class="text-center">
                    <a [hidden]="webInstruction.executionStatus === 'PENDING' || webInstruction.executionStatus === 'IN_PROGRESS' || !webInstruction.active " *ngIf="!webInstruction.browserScreenShot" (click)="openScreenShotModal(endPointExec?.webInstructions,ind)">View</a>
                    <a [hidden]="webInstruction.executionStatus === 'PENDING'" ngbTooltip="Click to enlarge the screenshot" *ngIf="webInstruction.browserScreenShot" class="thumbnail clickable" (click)="openScreenShotModal(endPointExec?.webInstructions,ind)">
                      <img class="img-thumbnail" [src]="'data:image/JPEG;base64,'+ webInstruction.browserScreenShot">
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="desc" *ngIf="webInstructionExpandable && projectConfiguration === 'PLAYWRIGHT'">
          <div class="table-container compact-table">
            <table class="result-table compact-table table-hover relay-word-wrap">
              <thead>
                <tr>
                  <th width="14%">Name</th>
                  <th width="10%">Primary Locator</th>
                  <th width="10%">Primary Input</th>
                  <th>Action</th>
                  <th class="text-center">Response(in sec)</th>
                  <th>Status</th>
                  <th width="12%" class="text-center">Extracted Value</th>
                  <th width="8%" class="text-center">Screenshot</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let webInstruction of endPointExec?.pwWebInstructions | orderBy:'asc':'sequence' ; index as ind;" [ngClass]="{'active' : (webInstActive === webInstruction.noSqlId),'inactive' : !webInstruction.active}">
                  <td>
                    <!-- <span [hidden]='!(webInstruction.active && webInstruction.domExtractors?.length > 0)' class="clickable fas" [ngClass]="(webResCollapsed && (webInstActive === webInstruction.noSqlId)) ? 'fa-chevron-circle-up' : 'fa-chevron-circle-down'" (click)="getResDomExtra(webInstruction.noSqlId)"></span> -->
                    {{webInstruction.name}}
                  </td>
                  <td *ngIf="webInstruction?.pwWebLocators && webInstruction?.pwWebLocators.length > 0">
                    <app-locator-pop-over [triggers]="'click'" [pwLocator]="webInstruction?.pwWebLocators ? webInstruction?.pwWebLocators[0] : null"></app-locator-pop-over>
                    <!-- <i class="far fa-edit clickable m-1" *ngIf="webInstruction?.pwWebLocators[0]" (click)="editPwWebInstruction(webInstruction?.pwWebLocators[0], 'webLocator');" title="Edit Web Instruction"></i> -->
                  </td>
                  <td *ngIf="!webInstruction?.pwWebLocators">
                    {{ 'N/A' }}
                  </td>
                  <td>{{webInstruction.pwWebInstructionInputs && webInstruction.pwWebInstructionInputs.length>0 ?
                        webInstruction.pwWebInstructionInputs[0].input : 'N/A'}}</td>
                  <td>{{webInstruction.actionOnComponent}}</td>
                  <td class="text-center">{{webInstruction?.webInstructionResponseTime}}</td>
                  <td>
                    <span class="badge" [ngClass]="{ 'badge-secondary' : (webInstruction.executionStatus === 'PENDING')
                                , 'badge-success' : (webInstruction.executionStatus === 'PASSED')
                                , 'badge-warning' : (webInstruction.executionStatus === 'SKIPPED')
                                , 'badge-danger' : (webInstruction.executionStatus === 'FAILED')
                                , 'badge-info' : (webInstruction.executionStatus === 'IN_PROGRESS')
                            }">
                      {{webInstruction.executionStatus}}
                    </span>
                  </td>
                  <td class="text-center">
                    <span class="link" container="body" ngbTooltip="View file" *ngIf="webInstruction?.extractedValue !== null && webInstruction?.actionOnComponent === 'SCREEN_CAPTURE'" (click)="viewImage(webInstruction, 'pwDomExtractedValue')">
                      {{webInstruction?.extractedValue}}
                    </span>
                    <span *ngIf="webInstruction?.extractedValue !== null && webInstruction?.actionOnComponent !== 'SCREEN_CAPTURE'">
                      {{webInstruction?.extractedValue}}
                    </span>
                    <span *ngIf="webInstruction?.extractedValue === null">
                      {{'N/A'}}
                    </span>
                  </td>
                  <td class="text-center">
                    <a (click)="openScreenShotModal(endPointExec.pwWebInstructions,ind)" *ngIf="webInstruction.executionStatus === 'FAILED'">View</a>
                    <span *ngIf="webInstruction.executionStatus !== 'FAILED'">N/A</span>
                  </td>
                  <!-- <td class="text-center">
                        <a [hidden]="webInstruction.executionStatus === 'PENDING' || webInstruction.executionStatus === 'IN_PROGRESS' || !webInstruction.active " *ngIf="!webInstruction.browserScreenShot" (click)="openScreenShotModal(endPointExec?.webInstructions,ind)">View</a>
                        <a [hidden]="webInstruction.executionStatus === 'PENDING'" ngbTooltip="Click to enlarge the screenshot" *ngIf="webInstruction.browserScreenShot" class="thumbnail clickable" (click)="openScreenShotModal(endPointExec?.webInstructions,ind)">
                          <img class="img-thumbnail" [src]="'data:image/JPEG;base64,'+ webInstruction.browserScreenShot">
                        </a>
                      </td> -->
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="web-results" [ngbCollapse]="!webResCollapsed" *ngIf="webInstructionExpandable">

          <div class="query-header-sec mt-3">
            <div class="title">DOM Extractor
              <i class="float-right fas clickable" [ngClass]="domCollapsed ? 'fa-chevron-circle-down' : 'fa-chevron-circle-up'" (click)="domCollapsed = !domCollapsed"></i>
            </div>
            <div class="desc" [ngbCollapse]="domCollapsed" class="table-container compact-table">
              <table class="result-table table-sm table-hover">
                <thead class="table-active">
                  <tr>
                    <th>Display Value</th>
                    <th>Locator</th>
                    <th>Dom Extractor Type</th>
                    <th>Extract From</th>
                    <th>Extracted Value</th>
                    <th>Response(in sec)</th>
                  </tr>
                </thead>
                <tr *ngIf="!domsRes || domsRes.length === 0">
                  <td colspan="6" class="no-result">No data found</td>
                </tr>
                <tr *ngFor="let domExtractor of domsRes; index as i;">
                  <td>{{domExtractor?.displayValue}}</td>
                  <td>
                    <app-locator-pop-over [locator]=domExtractor?.webLocator [by]=false [triggers]="'click'"></app-locator-pop-over>
                  </td>
                  <td>{{domExtractor?.domExtractorType}}</td>
                  <td>{{domExtractor?.extractFrom}}</td>
                  <td *ngIf="domExtractor?.domExtractorType === 'SCREEN_CAPTURE'">
                    <span class="link" ngbTooltip="View file" *ngIf="domExtractor?.extractedValue !== null" (click)="viewImage(domExtractor)">
                      {{domExtractor?.displayValue}}
                    </span>
                    <span *ngIf="domExtractor?.extractedValue === null">
                      {{domExtractor?.extractedValue}}
                    </span>
                  </td>
                  <td *ngIf="domExtractor?.domExtractorType !== 'SCREEN_CAPTURE'">
                    {{domExtractor?.extractedValue}}
                  </td>
                  <td>{{domExtractor?.domExtractorResponseTime}}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </ng-template>
    </li>
    <!-- Test data -->
    <li title="Test data" [ngbNavItem]="2" *ngIf="!endPointResults.mobileEndPoint && !endPointResults.desktopEndPoint">
      <a ngbNavLink><i class="fas fa-laptop-code mr-2"></i>Test data</a>
      <ng-template ngbNavContent>
        <div class="extra-box" *ngIf="syncTestdata.length === 0">Data not available</div>
        <div class="table-container compact-table">
          <table class="result-table" *ngIf="syncTestdata.length > 0">
            <thead>
              <tr class="font-weight-bold">
                <th width="10%">Key</th>
                <th width="10%">Data type</th>
                <th width="15%">Scope</th>
                <th width="10%">Extracted</th>
                <th width="10%">Global Input</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let syncedTestData of syncTestdata">
                <td>{{syncedTestData.key}}</td>
                <td>{{syncedTestData.dataType}}</td>
                <td>{{syncedTestData.testInputScope}}</td>
                <td>{{syncedTestData.fromResponseExtractor}}</td>
                <td>{{syncedTestData.fromGlobalTestInput}}</td>
                <td>
                  <div [hidden]="syncedTestData.fromResponseExtractor && true !== syncedTestData.fromGlobalTestInput">
                    <span class="relay-word-wrap" title="{{syncedTestData.value}}">{{syncedTestData.value}}</span>
                  </div>
                  <div [hidden]="!(syncedTestData.fromResponseExtractor && syncedTestData.responseExtractor?.responseSource !== 'DOM')">
                    <span *ngIf="syncedTestData.affixConfig !== null">{{syncedTestData.affixConfig.prefix}}</span>
                    <span class="relay-word-wrap">{{syncedTestData.responseExtractor?.extractedValue}}</span>
                    <span *ngIf="syncedTestData.affixConfig !== null">{{syncedTestData.affixConfig.suffix}}</span>
                  </div>
                  <div [hidden]="!(syncedTestData.fromResponseExtractor && syncedTestData.responseExtractor?.responseSource === 'DOM')">
                    <span *ngIf="syncedTestData.affixConfig !== null">{{syncedTestData.affixConfig.prefix}}</span>
                    <span class="relay-word-wrap">{{syncedTestData.responseExtractor?.domExtractor?.extractedValue}}</span>
                    <span *ngIf="syncedTestData.affixConfig !== null">{{syncedTestData.affixConfig.suffix}}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-template>
    </li>
    <!-- Testcase endpoint rules -->
    <li title="Rules" [ngbNavItem]="3" *ngIf="!isExecResult && !endPointResults.desktopEndPoint">
      <a ngbNavLink><i class="fas fa-ruler mr-2"></i>Rules</a>
      <ng-template ngbNavContent>
        <!-- Testcase endpoint rules -->
        <div class="extra-box" *ngIf="rulesList.length === 0">Data not available</div>
        <div *ngFor="let rules of rulesList">
          <div *ngIf="rules.actionConditionResults?.length > 0">
            <div style="background-color: #55b5d0;" class="d-flex">
              <h5 class="text-uppercase pl-1 pt-2 pb-2" style="font-weight: 600; ">{{rules.name}} </h5>
              <div class="ml-auto mt-1 mr-2" style="font-size: 20px; font-weight: 600;">{{rules.conditionType}}</div>
            </div>
            <h6 class="text-uppercase ml-2 mt-1">Conditions</h6>
            <div class="table-container compact-table">
              <table class="result-table">
                <thead>
                  <tr class="font-weight-bold">
                    <th width="10%">Result</th>
                    <th width="12%">Actual</th>
                    <th width="25%">Value</th>
                    <th width="10%">Condition</th>
                    <th width="12%">Expected</th>
                    <th width="25%">Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let actionCondition of rules.actionConditionResults">
                    <td [ngClass]="actionCondition.result">
                      {{actionCondition.result}}
                      <i class="fas fa-info-circle" *ngIf="actionCondition.message" ngbTooltip="{{actionCondition.message}}"></i>
                    </td>
                    <td>
                      {{actionCondition.leftSideResult.dataType}}
                      <small [hidden]="!(actionCondition?.leftSideResult?.dataType === 'GLOBAL')">
                        - {{actionCondition.leftSideResult?.globalTestInputKey?.name}}
                      </small>
                      <small [hidden]="!(actionCondition.leftSideResult?.dataType === 'EXTRACTOR')">
                        - {{actionCondition.leftSideResult?.responseExtractor?.displayValue}}
                      </small>
                    </td>
                    <td class="relay-word-wrap">
                      <span *ngIf="actionCondition.leftSideResult?.value !== null && actionCondition.leftSideResult?.value.length < 100">
                        {{actionCondition.leftSideResult?.value}}
                      </span>
                      <span class="text-muted" *ngIf="actionCondition.leftSideResult?.value && actionCondition.leftSideResult?.value.length > 100">
                        [...] <a class="text-right" (click)="openValueModal(actionCondition.leftSideResult?.value, actionCondition.leftSideResult?.globalTestInputKey?.name)">Click
                          to View</a>
                      </span>
                    </td>
                    <td>{{actionCondition.condition}}</td>
                    <td>
                      {{actionCondition.rightSideResult?.dataType}}
                      <small [hidden]="!(actionCondition.rightSideResult?.dataType === 'GLOBAL')">
                        - {{actionCondition.rightSideResult?.globalTestInputKey?.name}}
                      </small>
                      <small [hidden]="!(actionCondition.rightSideResult?.dataType === 'EXTRACTOR')">
                        - {{actionCondition.rightSideResult?.responseExtractor?.displayValue}}
                      </small>
                    </td>
                    <td class="relay-word-wrap">
                      <span *ngIf="actionCondition.rightSideResult?.value !== null && actionCondition.rightSideResult?.value.length < 100">
                        {{actionCondition.rightSideResult?.value}}
                      </span>
                      <span class="text-muted" *ngIf="actionCondition.rightSideResult?.value && actionCondition.rightSideResult?.value.length > 100">
                        [...] <a class="text-right" (click)="openValueModal(actionCondition.rightSideResult?.value, actionCondition.rightSideResult?.globalTestInputKey?.name)">Click
                          to View</a>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- Results -->
            <hr>
            <h6 class="text-uppercase ml-2">
              Actions on <span [ngClass]="rules.actionConditionsResult ? 'pass' : 'fail'">{{rules.actionConditionsResult ?
              'PASS' : 'FAIL'}}</span>
            </h6>
            <div class="table-container compact-table">
              <table class="result-table">
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>Global Key/Endpoint</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="rules.testCaseEndPointActionNoSqlDtos.length === 0">
                    <td colspan="3">No actions</td>
                  </tr>
                  <tr *ngFor="let item of rules.testCaseEndPointActionNoSqlDtos">
                    <td>{{item.actionType}}</td>
                    <td>
                      {{item.fromGlobalTestInput ? item.globalTestInputKey.name :
                    item.affectingTestCaseEndPoint.endPointName}}
                    </td>
                    <td>
                      <span *ngIf="item.actionType === 'RETRY'">
                        Max : {{item.retryConfig.maxRetry}} Delay : {{item.retryConfig.delayBetweenRetry}}
                      </span>
                      <span *ngIf="item.actionType !== 'RETRY'" style="word-break: break-word;">{{item.value ||
                      'NA'}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </ng-template>
    </li>
    <!-- Validation results -->
    <li title="Validation results" [ngbNavItem]="4" *ngIf="!endPointResults.mobileEndPoint && !endPointResults.desktopEndPoint">
      <a ngbNavLink><i class="fas fa-check-double mr-2"></i>Validation results</a>
      <ng-template ngbNavContent>
        <div class="row justify-content-end" *ngIf="validations.length > 0">
          <div class="col-md-auto font-bold p-0">Filter by:</div>
          <div class="col-3">
            <input type="text" class="form-control form-control-sm" [(ngModel)]="validationSearch" />
          </div>
        </div>

        <div class="common-table">
          <div class="extra-box" *ngIf="validations?.length === 0">Data not available</div>
          <div *ngFor="let validation of (validations | tableFilter: {name: validationSearch, validationResult: validationSearch}); let i = index; let last = last">
            <div *ngIf="validations.length > 0">
              <h6 class="text-uppercase ml-2 mt-1">{{i+1}}. Validation</h6>
              <div>
                <table class="result-table">
                  <thead>
                    <tr class="font-weight-bold">
                      <th width="17%">Name</th>
                      <th width="10%">Type</th>
                      <th width="20%">Expected Value</th>
                      <th width="20%">Actual Value</th>
                      <th width="18%" *ngIf="isImageCompareExists">Result Image</th>
                      <th width="10%" class="text-center">Status</th>
                      <th colspan="2">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{validation.name}}</td>
                      <td>{{validation.condition}}</td>
                      <td class="relay-word-wrap">
                        <div class="link" *ngIf="validation.actual?.extractorType === 'FILE' || validation.expected.isFile">
                          <span class="link" (click)="fileDownload(validation.expected.gridFsId)" *ngIf="validation.condition !=='IMAGE_COMPARE'" ngbTooltip="Click to download the file" container="body">
                            {{validation.expected.fileName}}
                          </span>
                          <span class="link" (click)="viewImage(validation, 'expectedFileName')" *ngIf="validation.condition ==='IMAGE_COMPARE'" ngbTooltip="View file" container="body">
                            {{validation.expected.fileName}}
                          </span>
                        </div>
                        <div class="link" *ngIf="validation.actual?.extractorType !== 'FILE' && !validation.expected.isExpectedIterable && validation.condition ==='IMAGE_COMPARE' && !validation.expected.isFile">
                          <span class="link" (click)="fileDownload(validation.expected.responseExtractor?.extractedValue)" *ngIf="validation.condition !=='IMAGE_COMPARE'" ngbTooltip="Click to download the file" container="body">
                            {{validation.expected.value || validation.expected.responseExtractor?.displayValue}}
                          </span>
                          <span class="link" (click)="viewImage(validation, 'expectedResponseExtractor')" *ngIf="validation.condition ==='IMAGE_COMPARE'" ngbTooltip="View file" container="body">
                            {{validation.expected.value || validation.expected.responseExtractor?.displayValue}}
                          </span>
                        </div>
                        <div *ngIf="validation.actual?.extractorType !== 'FILE' && !validation.expected.isExpectedIterable && validation.condition !=='IMAGE_COMPARE'">
                          <span class="text-muted" *ngIf="(validation?.expected?.value && validation?.expected?.value?.length > 100) || (validation.expected.responseExtractor?.extractedValue && validation.expected.responseExtractor?.extractedValue?.length > 100)">
                            [...] <a class="text-right" (click)="openValueModal(validation.expected.value || validation.expected.responseExtractor?.extractedValue)">Click
                              to View</a>
                          </span>
                          <span *ngIf="!((validation?.expected?.value && validation?.expected?.value?.length > 100) || (validation.expected.responseExtractor?.extractedValue && validation.expected.responseExtractor?.extractedValue?.length > 100))">
                            {{validation.expected.value || validation.expected.responseExtractor?.extractedValue}}
                          </span>
                        </div>
                        <div class="link" *ngIf="validation.expected.isExpectedIterable && validation.condition ==='IMAGE_COMPARE'">
                          <span class="link" (click)="fileDownload(validation.expected.responseExtractor?.extractedValue)" *ngIf="validation.condition !=='IMAGE_COMPARE'" ngbTooltip="Click to download the file" container="body">
                            {{validation.expected.value || validation.expected.responseExtractor?.displayValue}}
                          </span>
                          <span class="link" (click)="viewImage(validation, 'expectedResponseExtractor')" *ngIf="validation.condition ==='IMAGE_COMPARE'" ngbTooltip="View file" container="body">
                            {{validation.expected.value || validation.expected.responseExtractor?.displayValue}}
                          </span>
                        </div>
                        <div *ngIf="validation.expected.isExpectedIterable && validation.condition !=='IMAGE_COMPARE'" ngbTooltip="Index : {{validation.expected.expectedIndex}} Key : {{validation.expected.expectedIterableKey}}">
                          {{validation.expected.expectedValue}}
                        </div>
                      </td>
                      <td class="relay-word-wrap">
                        <div class="link" *ngIf="validation.actual?.extractorType === 'FILE'">
                          <span class="link" (click)="fileDownload(validation.actual?.extractedValue)" *ngIf="validation.condition !=='IMAGE_COMPARE'" ngbTooltip="Click to download the file" container="body">
                            {{validation.actual.downloadedFileName || validation.actual?.displayName}}
                          </span>
                          <span class="link" (click)="viewDomImageFile(validation , 'downloadedFilename')" *ngIf="validation.condition ==='IMAGE_COMPARE'" ngbTooltip="View file" container="body">
                            {{validation.actual.downloadedFileName || validation.actual?.displayName}}
                          </span>
                        </div>
                        <div class="link" *ngIf="validation.actual?.extractorType !== 'FILE' && !validation.isActualIterable && validation.condition ==='IMAGE_COMPARE' && validation.actual?.extractedValue !== null && projectConfiguration !== 'PLAYWRIGHT'">
                          <span class="link" (click)="fileDownload(validation.actual?.extractedValue)" *ngIf="validation.condition !=='IMAGE_COMPARE'" ngbTooltip="Click to download the file" container="body">
                            {{validation.actual?.domExtractor?.displayValue}}
                          </span>
                          <span class="link" (click)="viewDomImageFile(validation, 'domExtractor')" *ngIf="validation.condition ==='IMAGE_COMPARE'" ngbTooltip="View file" container="body">
                            {{validation.actual?.domExtractor?.displayValue}}
                          </span>
                        </div>
                        <div class="link" *ngIf="validation.actual?.extractorType !== 'FILE' && !validation.isActualIterable && validation.condition ==='IMAGE_COMPARE' && validation.actual?.extractedValue === null  && projectConfiguration !== 'PLAYWRIGHT'">
                          {{validation.actual?.domExtractor?.extractedValue}}
                        </div>
                        <div class="link" *ngIf="validation.actual?.extractorType !== 'FILE' && !validation.isActualIterable && validation.condition ==='IMAGE_COMPARE' && validation.actual?.extractedValue !== null && projectConfiguration === 'PLAYWRIGHT'">
                          <span class="link" (click)="fileDownload(validation.actual?.extractedValue)" *ngIf="validation.condition !=='IMAGE_COMPARE'" ngbTooltip="Click to download the file" container="body">
                            {{validation.actual?.displayValue}}
                          </span>
                          <span class="link" (click)="viewDomImageFile(validation)" *ngIf="validation.condition ==='IMAGE_COMPARE'" ngbTooltip="View file" container="body">
                            {{validation.actual?.displayValue}}
                          </span>
                        </div>
                        <div class="link" *ngIf="validation.actual?.extractorType !== 'FILE' && !validation.isActualIterable && validation.condition ==='IMAGE_COMPARE' && validation.actual?.extractedValue === null  && projectConfiguration === 'PLAYWRIGHT'">
                          {{ validation.actual?.extractedValue ? validation.actual?.extractedValue : null }}
                        </div>
                        <div *ngIf="validation.actual?.extractorType !== 'FILE' && !validation.isActualIterable && validation.condition !=='IMAGE_COMPARE'">
                          <span class="text-muted" *ngIf="(validation.actual?.extractedValue && validation.actual?.extractedValue.length > 100) || (validation.actual?.displayValue && validation.actual?.displayValue.length > 100)">
                            [...] <a class="text-right" (click)="openValueModal(validation.actual?.extractedValue || validation.actual?.displayValue)">Click
                              to View</a>
                          </span>
                          <span *ngIf="!((validation.actual?.extractedValue && validation.actual?.extractedValue.length > 100) || (validation.actual?.displayValue && validation.actual?.displayValue.length > 100))">
                            {{validation.actual?.extractedValue || validation.actual?.displayValue}}
                          </span>
                        </div>
                        <div class="link" *ngIf="validation.isActualIterable && validation.condition ==='IMAGE_COMPARE' && validation.actual?.extractedValue !== null">
                          <span class="link" (click)="fileDownload(validation.actual?.extractedValue)" *ngIf="validation.condition !=='IMAGE_COMPARE'" ngbTooltip="Click to download the file" container="body">
                            {{validation.actual?.displayValue}}
                          </span>
                          <span class="link" (click)="viewDomImageFile(validation)" *ngIf="validation.condition ==='IMAGE_COMPARE'" ngbTooltip="View file" container="body">
                            {{validation.actual?.displayValue}}
                          </span>
                        </div>
                        <div class="link" *ngIf="validation.isActualIterable && validation.condition ==='IMAGE_COMPARE' && validation.actual?.extractedValue === null">
                          {{validation.actual?.extractedValue}}
                        </div>
                        <div *ngIf="validation.isActualIterable && validation.condition !=='IMAGE_COMPARE'" ngbTooltip="Index : {{validation.actualIndex}} Key : {{validation.actualIterableKey}}">
                          {{validation.actualValue}}
                        </div>
                      </td>
                      <td class="relay-word-wrap" *ngIf="isImageCompareExists && validation.imageCompareResultFile !== null">
                        <span class="link" ngbTooltip="View file" container="body" (click)="viewImage(validation , 'imageCompareResultFile')">
                          {{validation.imageCompareResultFile?.fileName}}
                        </span>
                      </td>
                      <td *ngIf="isImageCompareExists && validation.imageCompareResultFile === null"></td>
                      <td class="text-center">
                        <span *ngIf="validation.skipValidation">
                          <i class="fas fa-info clickable text-warning" ngbTooltip="{{validation.skippedMessage}}"></i>
                          {{validation.validationResult}}
                        </span>
                        <span *ngIf="!validation.skipValidation" [class.text-danger]="validation.validationResult ==='FAILED'">{{validation.validationResult}}</span>
                        <i class="fas fa-exclamation-triangle clickable ml-1" *ngIf="validation.failedMessage" [ngbPopover]="popContentFailMsg" [popoverTitle]="popFailMsg"></i>
                        <i class="fas fa-exclamation-triangle clickable ml-1" *ngIf="validation.passedMessage && validation.condition === 'IMAGE_COMPARE'" [ngbPopover]="popContentPassMsg" [popoverTitle]="popPassMsg"></i>

                        <ng-template #popFailMsg><b class="text-danger">Error</b></ng-template>
                        <ng-template #popContentFailMsg>{{validation.failedMessage}}</ng-template>
                        <ng-template #popPassMsg><b class="text-success">Success</b></ng-template>
                        <ng-template #popContentPassMsg>{{validation.passedMessage}}</ng-template>
                      </td>
                      <td>
                        <div *ngFor="let postAction of validation.postValidationActionNoSqlDtos">
                          {{postAction.action}}
                          <span *ngIf="postAction.endPoint">to</span>
                          {{postAction.endPoint.name}}
                        </div>
                      </td>
                      <td>
                        <i class="far fa-list-alt" (click)="getMultipleValidationRes(validation.expected,validation.actual.responseExtractorResult)" ngbTooltip="View multiple excepted & actual result" [hidden]="!(validation.expected.responseExtractor?.responseExtractorResult.length > 1) || validation.actual.responseExtractorResult.length > 1"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div *ngIf="validation.postValidationActionsPerformed">
                <hr>
                <h6 class="text-uppercase ml-2">
                  Actions on <span>{{validation.validationResult === 'PASSED' ? 'PASS' : 'FAIL'}}</span>
                </h6>
                <div class="table-container compact-table">
                  <table class="result-table">
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th>Endpoint</th>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngIf="validations.length === 0">
                        <td colspan="3">No actions</td>
                      </tr>
                      <tr *ngFor="let item of validation.postValidationActionsPerformed">
                        <td>{{item?.action}}</td>
                        <td>
                          {{item?.actionEndPointName ? item?.actionEndPointName :'N/A'}}
                        </td>
                        <td>
                          <span *ngIf="item.action === 'RETRY'">
                            Max : {{item.retryConfig?.maxRetry}} Delay : {{item.retryConfig?.delayBetweenRetry}}
                          </span>
                          <span *ngIf="item.action !== 'RETRY'">
                            NA
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <hr *ngIf="!last" style="border: 3px solid #fff !important">
            </div>
          </div>
        </div>
      </ng-template>
    </li>
    <!-- Dom Extractors -->
    <li title="Dom Extractors" [ngbNavItem]="5" [hidden]="!isExecResult && !endPointResults.webEndPoint" *ngIf="projectConfiguration !== 'PLAYWRIGHT'">
      <a ngbNavLink><i class="fas fa-code mr-2"></i>DOM Extractors</a>
      <ng-template ngbNavContent>
        <div class="extra-box" *ngIf="testCaseResponseExtractor.length === 0">Data not available</div>
        <div class="table-container compact-table">
          <table class="result-table" *ngIf="testCaseResponseExtractor.length > 0">
            <thead>
              <tr class="font-weight-bold">
                <th>Display value</th>
                <th>Locator type</th>
                <th>Locator string</th>
                <th>DOM Type</th>
                <th>Extract from</th>
                <th>Extracted value</th>
                <th>Response(in sec)</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let responseExtractor of testCaseResponseExtractor; index as ind;">
                <tr *ngIf="responseExtractor.domExtractor!==null">
                  <td>{{responseExtractor.domExtractor?.displayValue}}</td>
                  <td>{{responseExtractor.domExtractor?.webLocator?.locatorType}}</td>
                  <td class="relay-word-wrap">{{responseExtractor.domExtractor?.webLocator?.locatorString}}</td>
                  <td>{{responseExtractor.domExtractor?.domExtractorType}}</td>
                  <td>{{responseExtractor.domExtractor?.extractFrom}}</td>
                  <td class="relay-word-wrap" *ngIf="responseExtractor.domExtractor?.domExtractorType !=='SCREEN_CAPTURE'">
                    {{responseExtractor.domExtractor?.extractedValue}}</td>
                  <td class="relay-word-wrap" *ngIf="responseExtractor.domExtractor?.domExtractorType ==='SCREEN_CAPTURE'">
                    <span class="link" ngbTooltip="View file" *ngIf="responseExtractor.domExtractor?.extractedValue !== null" (click)="viewImage(responseExtractor, 'domExtractedValue')">
                      {{responseExtractor.domExtractor?.displayValue}}.png
                    </span>
                    <span *ngIf="responseExtractor.domExtractor?.extractedValue === null">
                      {{responseExtractor.domExtractor?.extractedValue}}
                    </span>
                  </td>
                  <td>{{responseExtractor.domExtractor?.domExtractorResponseTime}}</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </ng-template>
    </li>
    <!-- Response Extractor -->
    <li title="Response Extractor" [ngbNavItem]="6" *ngIf="projectConfiguration !== 'PLAYWRIGHT' && !endPointResults.mobileEndPoint && !endPointResults.desktopEndPoint">
      <a ngbNavLink><i class="fas fa-exchange-alt mr-2"></i>Response Extractor</a>
      <ng-template ngbNavContent>
        <div class="extra-box" *ngIf="testCaseResponseExtractor.length === 0">Data not available</div>
        <div class="table-container compact-table" style="overflow: scroll">
          <table class="result-table" *ngIf="testCaseResponseExtractor.length > 0">
            <thead>
              <tr class="font-weight-bold">
                <th width="5%"><input type="checkbox" ngbTooltip="Format All" class="mr-1" style="margin-left: 0.4rem" (click)="formatAll($event)"></th>
                <th width="20%">Display Value</th>
                <th width="35%">Path To Extract</th>
                <th width="40%">Extracted Value</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let responseExtractor of testCaseResponseExtractor; let i=index">
                <tr *ngIf="responseExtractor.responseSource !== 'DOM'">
                  <td><input type="checkbox" [(ngModel)]="responseExtractor.showFormattedCode"></td>
                  <td>{{responseExtractor.displayValue}}
                    <span ngbTooltip="JavaScript Experessions" *ngIf="responseExtractor.extractorType === 'JS_FUNCTION'" class="badge badge-info mr-1">JE</span>
                    <small style="font-size: 10px" class="note" [hidden]="!responseExtractor.responseSource">({{responseExtractor.responseSource}})</small>
                  </td>
                  <td>{{responseExtractor.pathToExtract || 'NA'}}</td>
                  <td class="relay-word-wrap d-flex" *ngIf="!responseExtractor.lazy">
                    <pre *ngIf="responseExtractor.showFormattedCode">{{responseExtractor?.extractedValue}}</pre>
                    <div *ngIf="!responseExtractor.showFormattedCode">{{responseExtractor?.extractedValue}}</div>
                    <!-- <i class="fas fa-exclamation"></i> -->
                    <i class="fas fa-bug text-danger clickable m-1" *ngIf="responseExtractor.errorMessage !== null && responseExtractor.extractorType === 'JS_FUNCTION' " ngbPopover="" [ngbPopover]="popContent" [popoverTitle]="popTitle" placement="left"></i>
                    <ng-template #popTitle><b class="text-danger">Error</b></ng-template>
                    <ng-template #popContent>{{responseExtractor.errorMessage}}</ng-template>
                  </td>
                  <td *ngIf="responseExtractor.lazy">
                    <a (click)="getResponseExtractorById(responseExtractor, i)">Data is too long. Click here to view the data.</a>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </ng-template>
    </li>
    <!-- Playwright Response Extractor -->
    <li title="Playwright Response Extractor" [ngbNavItem]="7" *ngIf="projectConfiguration === 'PLAYWRIGHT' && !endPointResults.mobileEndPoint && !endPointResults.desktopEndPoint">
      <a ngbNavLink><i class="fas fa-exchange-alt mr-2"></i>Response Extractors</a>
      <ng-template ngbNavContent>
        <div class="extra-box" *ngIf="testCaseResponseExtractor.length === 0">Data not available</div>
        <div class="table-container compact-table">
          <table class="result-table" *ngIf="testCaseResponseExtractor.length > 0">
            <thead>
              <tr>
                <th width="25%">Display Value</th>
                <th width="35%">Path To Extract</th>
                <th width="40%">Extracted Value</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let responseExtractor of testCaseResponseExtractor">
                <tr *ngIf="responseExtractor.responseSource !== 'DOM'">
                  <td>{{responseExtractor.displayValue}}
                    <span ngbTooltip="JavaScript Experessions" *ngIf="responseExtractor.extractorType === 'JS_FUNCTION'" class="badge badge-info mr-1">JE</span>
                    <small style="font-size: 10px" class="note" [hidden]="!responseExtractor.responseSource">({{responseExtractor.responseSource}})</small>
                  </td>
                  <td>{{responseExtractor.pathToExtract || 'NA'}}</td>
                  <td class="relay-word-wrap">
                    {{responseExtractor?.extractedValue}}
                    <!-- <i class="fas fa-exclamation"></i> -->
                    <i class="fas fa-bug text-danger clickable" *ngIf="responseExtractor.errorMessage !== null && responseExtractor.extractorType === 'JS_FUNCTION' " ngbPopover="" [ngbPopover]="popContent" [popoverTitle]="popTitle" placement="left"></i>
                    <ng-template #popTitle><b class="text-danger">Error</b></ng-template>
                    <ng-template #popContent>{{responseExtractor.errorMessage}}</ng-template>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </ng-template>
    </li>
    <!-- RequestSection for API -->
    <li title="Request" [ngbNavItem]="8" *ngIf="!endPointResults.webEndPoint && !endPointResults.mobileEndPoint && !endPointResults.desktopEndPoint">
      <a ngbNavLink><i class="fas fa-list-ul mr-2"></i>Request</a>
      <ng-template ngbNavContent>
        <div class="row">
          <!-- Request Body -->
          <div class="report-visualization col-6" *ngIf="endPointExec?.requestBody !== null && (endPointExec?.requestBody | json) !== '{}'">
            <div class="stats-panel">
              <div class="panel-header">
                <h3 class="panel-title">{{endPointResults?.endPointType === 'GRAPHQL'?'Query':'Request Body'}}</h3>
              </div>
            </div>
            <div class="stats-body">
              <div class="overflow">
                <ngx-json-viewer [json]="endPointExec?.requestBody"></ngx-json-viewer>
              </div>
            </div>
          </div>
          <div class="report-visualization col-6" *ngIf="endPointExec?.requestParams !== null && (endPointExec?.requestParams | json) !== '{}'">
            <div class="stats-panel">
              <div class="panel-header">
                <h3 class="panel-title">{{endPointResults?.endPointType === 'GRAPHQL'?'Graphql Variables':'Query Param'}}</h3>
              </div>
            </div>
            <div class="stats-body">
              <div class="overflow">
                <ngx-json-viewer [json]=endPointExec.requestParams></ngx-json-viewer>
              </div>
            </div>
          </div>
          <div class="report-visualization col-6" *ngIf="endPointExec?.requestHeaders !== null && (endPointExec?.requestHeaders | json) !== '{}'">
            <div class="stats-panel">
              <div class="panel-header">
                <h3 class="panel-title">Request Headers</h3>
              </div>
            </div>
            <div class="stats-body">
              <div class="overflow">
                <ngx-json-viewer [json]=endPointExec.requestHeaders></ngx-json-viewer>
              </div>
            </div>
          </div>
          <!-- Multipart Body -->
          <div class="report-visualization col-6" *ngIf="endPointExec?.multipartFormData !== null && (endPointExec?.multipartFormData | json) !== '{}'">
            <div class="stats-panel">
              <div class="panel-header">
                <h3 class="panel-title">Multipart</h3>
              </div>
            </div>
            <div class="stats-body">
              <div class="overflow">
                <ngx-json-viewer [json]="endPointExec?.multipartFormData" open></ngx-json-viewer>
              </div>
            </div>
          </div>
          <!-- Binary Body -->
          <div class="report-visualization col-6" *ngIf="endPointExec?.binaryData !== null && (endPointExec?.binaryData | json) !== '{}'">
            <div class="stats-panel">
              <div class="panel-header">
                <h3 class="panel-title">Binary data</h3>
              </div>
            </div>
            <div class="stats-body">
              <div class="overflow">
                <ngx-json-viewer [json]="endPointExec?.binaryData" open="10"></ngx-json-viewer>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </li>
    <li title="Request Body" [ngbNavItem]="9" *ngIf="endPointExec !== undefined && endPointExec['requestBody'] && endPointResults.webEndPoint">
      <a ngbNavLink><i class="fas fa-list-ul mr-2"></i>Request Body</a>
      <ng-template ngbNavContent>
        <div class="common-box overflow">
          <span [hidden]="!(endPointExec?.responseType === 'JSON')">
            <ngx-json-viewer [json]="endPointExec['requestBody']"></ngx-json-viewer>
          </span>
          <span [hidden]="!(endPointExec?.responseType !== 'JSON')">
            <pre>{{endPointExec['requestBody']}}</pre>
          </span>
        </div>
      </ng-template>
    </li>

    <li title="Multiple execution" [ngbNavItem]="11" *ngIf="endPointExec?.endPointExecutionResults?.length >= 1">
      <a ngbNavLink><i class="fas fa-list-ul mr-2"></i>Multiple execution</a>
      <ng-template ngbNavContent>
        <div class="row">
          <div class="common-section col-12">
            <div class="table-container compact-table">
              <table class="result-table">
                <thead>
                  <tr>
                    <th width="13%">Start Time</th>
                    <th width="13%">End Time</th>
                    <th width="30%">Response String</th>
                    <th width="15%" class="text-center">Invoice</th>
                    <th width="19%">Exception</th>
                    <th width="10%" class="text-center">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let endPointExecutionResults of endPointExec?.endPointExecutionResults">
                    <td>{{endPointExecutionResults.startTime | localDate}}</td>
                    <td>{{endPointExecutionResults.endTime | localDate}}</td>
                    <td class="relay-word-wrap">{{endPointExecutionResults.responseBodyString}}</td>
                    <td class="text-center">
                      <img [hidden]="!endPointExecutionResults.invoiceNumber" src="app/assets/images/icons/pdf.png" alt="PDF - {{endPointExecutionResults.invoiceNumber}}" class="clickable" title="Click to download" (click)="getInovice(endPointExecutionResults.invoiceNumber)">
                      <br [hidden]="!endPointExecutionResults.invoiceNumber" />
                      <span>{{endPointExecutionResults.invoiceNumber || 'NA'}}</span>
                    </td>
                    <td class="relay-word-wrap">{{endPointExecutionResults?.exceptionText || 'NA'}}</td>
                    <td class="text-center">{{endPointExecutionResults.executionStatus}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>